import { Injectable, inject } from '@angular/core';
// import jwt_decode from "jwt-decode";
import { Observable, of, tap } from 'rxjs';
import { SharedService }  from "./shared.service";
import { IAuthToken } from '../interfaces/auth-token';
import { IDestinationOption } from '../interfaces/destination-option';

const AUTH_TOKEN = 'auth-token';
const USER_PRIVILEGES = 'user-privs';
const OTP_DEST_OPTIONS = 'otp-dest-options';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private sharedService = inject(SharedService);

  constructor() { }

  // Save the auth token in the local storage
  public setAuthToken (authToken: string): void {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.setItem(AUTH_TOKEN, authToken);
  }

  // Retrieve the auth token from the local storage
  public getAuthToken(): string | null {
    return localStorage.getItem(AUTH_TOKEN);
  }  

  // Find out the OTP session from the auth token
  public getOtpSessionId(): string | null {
    let tokenString: string = this.getAuthToken() || '';
    // console.log('getOtpSessionId - tokenString', tokenString);

    if (tokenString) {
      // let authToken : IAuthToken = jwt_decode(tokenString);
      let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
      console.log('getOtpSessionId - authToken', authToken);
      return authToken.otps; 
    } else {
      return null;
    }
  }  

  // Save the user privileges in the local storage
  public setUserPrivileges (userPrivileges: string[]): void {
    console.log('setUserPrivileges',userPrivileges);
    localStorage.removeItem(USER_PRIVILEGES);
    localStorage.setItem(USER_PRIVILEGES, userPrivileges.join('|'));
  }

  // Retrieve the user privileges from the local storage
  public getUserPrivileges(): string[] | null {
    return (localStorage.getItem(USER_PRIVILEGES)  || '').split('|');
  }  

  // Verify whether the current user is authorized against different claims
  public isUserAuthorized(requiredPrivileges: string[]): Observable<boolean> {
    let isUserAuthorized: boolean = false;
    // if (!this.isTokenExpired()) {
      if (this.arePrivilegesGranted(requiredPrivileges)) {
        isUserAuthorized = true;
      }
    // }
    return of(isUserAuthorized).pipe(tap((v) => console.log(v)));
  }

  public setDestinationOptions(destinationOptions: IDestinationOption[]) {
    localStorage.removeItem(OTP_DEST_OPTIONS);
    localStorage.setItem(OTP_DEST_OPTIONS, JSON.stringify(destinationOptions));
  }

  public getDestinationOptions(): IDestinationOption[] {
    let json: string | null = localStorage.getItem(OTP_DEST_OPTIONS);
    if (json) {
      return JSON.parse(json);
    } else {
      return [];
    }
  }    

  // Verify whether the auth token has not expired yet
  // private isTokenExpired(): boolean {
  //   let isTokenExpired: boolean = true;
  //   let tokenString: string = this.getAuthToken() || '';
  //   if (tokenString) {
  //     // let authToken : IAuthToken = jwt_decode(tokenString);
  //     let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
  //     isTokenExpired = authToken.exp * 1000 > Date.now();
  //   }
  //   return isTokenExpired;
  // }

  // Verify that the auth token has required privileges
  private arePrivilegesGranted(requiredPrivileges: string[]): boolean {
    requiredPrivileges.forEach(reqPriv => {
      // const decoded: string = Buffer.from(reqPriv, 'base64').toString('utf8');
    })
    return true;
  }

}
